import { ErrorState } from "$components/error-state";
import { linkToLogin } from "$routes/user/links";
import { useAuth0 } from "@auth0/auth0-react";
import type { FC, ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

interface Props {
  title?: ReactNode;
  body?: ReactNode;
}

export const Auth0ErrorPage: FC<Props> = ({ title, body }) => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const isDevelopment = ["localhost", "127.0.0.1"].includes(
    window.location.hostname,
  );

  function handleBackToLogin() {
    logout();
    navigate(linkToLogin());
  }

  // Devs were seeing this error quite a lot when working locally,
  // 90% of the time it was just that one of the services hadn't started properly
  const defaultTitle = isDevelopment ? (
    "Authentication error"
  ) : (
    <FormattedMessage
      id="auth.errorPage.defaultTitle"
      defaultMessage="Unauthorised"
    />
  );
  const defaultMessage = isDevelopment ? (
    "Please check both auth services are running. If everything is running correctly, check your user is present in Mongo and not set as inactive"
  ) : (
    <FormattedMessage
      id="auth.errorPage.body"
      defaultMessage="Please contact your Elephant system administrator for assistance."
    />
  );

  return (
    <ErrorState
      title={title || defaultTitle}
      body={body || defaultMessage}
      onRetry={handleBackToLogin}
      retryLabel={
        <FormattedMessage
          id="auth.errorPage.button"
          defaultMessage="Back to login"
        />
      }
      contactSupport={false}
    />
  );
};
